import { Select } from '../../atoms/select/Select';
import styles from './ProductActions.module.scss';
import React from 'react';
import { CarretArrowDownJAG } from '../../atoms/icons';
import { optionsActions, sizeSelectorOptions } from './options';
import { Variant } from '@srcDS/components/organisms/productActions/types';


interface SizeSelectorProps {
  isSelectingSize: boolean;
  variants: Variant[];
  variant: Variant | null;
  register: any; // You should replace `any` with the appropriate type for register from `react-hook-form`
  statusMenu: { status: boolean; label: boolean };
  setValue: (name: string, value: any) => void;
  onChangeVariant: (selected: Variant) => void;
  selectVariant: (selected: Variant) => void;
  customArgs: Record<string, any>; // Any extra props passed to Select
  setQty: (quantity: number) => React.ReactNode;
  setActiveOption: (selected: Variant) => void;
  label: React.ReactNode | string;
  displayAlphaSize?: boolean;
}

export const SizeSelector: React.FC<SizeSelectorProps> = ({
  isSelectingSize,
  variants,
  variant,
  register,
  statusMenu,
  setValue,
  onChangeVariant,
  selectVariant,
  customArgs,
  setQty,
  setActiveOption,
  label,
  displayAlphaSize,
}) => {
  const defaultValue = isSelectingSize
    ? null
    : variant?.projectSpecificData?.availableQuantity > 0
      ? variant.sku
      : null;

  return variants ? (
    <Select
      register={register}
      name="size"
      /*@ts-ignore*/
      customIcon={optionsActions?.isJag && CarretArrowDownJAG}
      defaultExpaned={statusMenu}
      isPlaceholder={true}
      className={styles.customSize}
      customClasses={{
        selectDropdown: styles.selectDropdown,
        after: styles.after,
      }}
      selectAriaLabel="Size selector"
      onChange={(event) => {
        let selected;
        selected = variants.find((el) => el.value === event.target.value);
        setValue('size1', event.target.value);
        setValue('size2', event.target.value);
        setValue('size3', event.target.value);
        onChangeVariant(selected);
        selectVariant(selected);
        setActiveOption(selected);
      }}
      {...customArgs}
      {...sizeSelectorOptions}
      /*@ts-ignore*/
      label={label}
    >
      {variants &&
        variants.map(({ value: val, label, projectSpecificData, attributes }, index) => {
          const isOutOfStock = projectSpecificData?.availableQuantity <= 0;
          // @ts-ignore
          return (
            <Select.Option
              ariaLabel={label}
              selected={val === defaultValue}
              key={label + val}
              index={index}
              label={label}
              value={val}
              isOutOfStock={projectSpecificData?.availableQuantity <= 0}
              className={styles.selectListItem}
              htmlContent={
                displayAlphaSize ? (
                  <div className={styles.selectListItemContent}>
                    <div className={styles.selectListItemLabel}>
                      <span className={isOutOfStock ? styles.outOfStockText : ''}>{label}</span>
                      {setQty(projectSpecificData?.availableQuantity)}
                    </div>
                    {attributes?.alphasize && <span className={styles.alphaSize}>{attributes?.alphasize}</span>}
                  </div>
                ) : (
                  <>
                    <span>{label}</span>
                    {setQty(projectSpecificData?.availableQuantity)}
                  </>
                )
              }
            />
          );
        })}
    </Select>
  ) : null;
};
